import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6465d1bb&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
import style0 from "./List.vue?vue&type=style&index=0&id=6465d1bb&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=6465d1bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6465d1bb",
  null
  
)

export default component.exports